import React from 'react'
import { connect } from 'react-redux'

const styles = {
  root: {
    textAlign: 'center',
  },
  video: {
    width: '80%',
    height: 'auto',
    maxHeight: '550px',
  },
}

class VideoPage extends React.Component {

  render() {
    const { mission_page } = this.props
    return (
      <div style={styles.root}>
        <video style={styles.video} src={mission_page.media_url} alt={`Imagen ${mission_page.id}`} controls />
      </div>
    )
  }

}

VideoPage.propTypes = {
  mission_page: React.PropTypes.shape({
    id: React.PropTypes.number.isRequired,
  }).isRequired,
}

const mapStateToProps = state => ({
  ...state,
})

const mapDispatchToProps = () => ({
})


export default connect(mapStateToProps, mapDispatchToProps)(VideoPage)



// WEBPACK FOOTER //
// ./src/components/MissionShow/MissionPage/VideoPage/index.jsx